var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Main',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}]}),_c('Background',{attrs:{"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }